import script from "./MockProductGridTile.vue?vue&type=script&setup=true&lang=js"
export * from "./MockProductGridTile.vue?vue&type=script&setup=true&lang=js"

import "./MockProductGridTile.vue?vue&type=style&index=0&id=2ccf1e52&lang=scss"

const __exports__ = script;

export default __exports__